import CarBreadcrumb from "../../commonComponents/breadcrumbs/CarBreadcrumb";
import CarDetail from "../../commonComponents/productDetail/CarDetail";

const CarModernSliderContainer = () => {
  return (
    <>
      <CarBreadcrumb mailClass="car-home-section" modernSlider detailImages/>
      <CarDetail type="car" />
    </>
  );
};

export default CarModernSliderContainer;
